import { writable } from 'svelte/store';
import type { ProfileAttrs, ProfileAttrsArray } from './viewProfile.type';

export const viewProfileStore = writable<ProfileAttrs>({
	username: '',
	realname: '',
	avatar_url: '',
	member: false,
	id: '',
	website: '',
	timezone: '',
	role: '',
	availability: 0.0,
	bio: '',
	persona: '',
	twitter: '',
	linkedin: '',
	github: '',
	communities: [],
	skills: [],
	profileredirects: undefined,
	redirect: undefined,
	wallet: '',
	localbloom: '',
	placename: '',
	needs: [],
	offers: [],
	localbloom_systemname: ''
});

export const profileSchema: ProfileAttrs = {
	username: '',
	realname: '',
	avatar_url: '',
	member: false,
	id: '',
	website: '',
	timezone: '',
	role: '',
	availability: 0.0,
	bio: '',
	persona: '',
	twitter: '',
	linkedin: '',
	github: '',
	communities: [],
	skills: [],
	profileredirects: undefined,
	redirect: undefined,
	localbloom: '',
	placename: '',
	needs: [],
	offers: [],
	localead: false,
	localbloom_systemname: ''
};

export const viewMemberStore = writable<ProfileAttrs>(profileSchema);
export const viewProfiles = writable<ProfileAttrsArray>([profileSchema]);
